
import { EmailBrandingTabList } from '@/entities/OrganizationalSettings/EmailBrandingTabList';
import EmailBrandingListings from './EmailBrandingListings.vue';
import { TabViewModel } from '@/entities/TabViewModel';
import { Component, toNative, Vue } from 'vue-facing-decorator';
import VueTabs from '@/components/Common/Tabs.vue';
import EmailBrandingDrawer from './EmailBrandingDrawer.vue';
import { FetchData, Root, Store } from '@/main';
import EmailDomainManager from './EmailDomainManager.vue';
import { EmailBrandingViewModel } from '@/entities/OrganizationalSettings/EmailBrandingViewModel';
import { EmailDomainsViewModel } from '@/entities/OrganizationalSettings/EmailDomainsViewModel';
import EmailListingsModel from '@/entities/OrganizationalSettings/EmailListingsModel';
import EmailBrandingHelper from '@/helper/EmailBrandingHelper';
import loading from '@/components/Common/loading.vue';
import Toaster from '@/components/Common/Toaster.vue';
import ModalPopup from '@/components/Common/ModalPopup.vue';
import DomainStatusTypeEnum from '@/enums/DomainStatusTypeEnum';
import { StoreHelper } from '@/store/StoreHelper';
import EmailDomainDrawerTypeEnum from '@/enums/EmailDomainDrawerTypeEnum';
@Component({
  components: {
    VueTabs,
    EmailBrandingListings,
    EmailBrandingDrawer,
    EmailDomainManager,
    loading,
    Toaster,
    ModalPopup,
  },
})
class EmailBranding extends Vue {
  private tabViewModel: EmailBrandingTabList = new EmailBrandingTabList();
  private emailBrandingTabEntityList: TabViewModel[] = this.tabViewModel.TabViewModels;
  private domainRecords = EmailDomainsViewModel.createEmpty();
  private domainGlobeIcon = require('@/assets/Images/globe-icon.svg');
  private addActionIcon = require('@/assets/Images/add-action-icon.svg');
  private deleteIcon = require('@/assets/Images/bin-icon.svg');
  private warningStatusIcon  = require('@/assets/Images/warning-status-icon.svg');
  private infoStatusIcon = require('@/assets/Images/blue-icon-icon.svg');
  private openDrawer = false;
  private isDomainTooltipVisible = false;
  private emailDomainListings: EmailBrandingViewModel[] = [];
  private selectedDrawerType = EmailBrandingHelper.DomainDrawer;
  private defaultDrawerWidth = '40%';
  private editEmailData = EmailListingsModel.createEmpty();
  private toasterDefaultTimeout = EmailBrandingHelper.ToasterTimeOut;
  private loaderDefaultTimeout = EmailBrandingHelper.LoaderTimeOut;
  private toasterMessage = '';
  private loaderBorderColor = '';
  private showLoading = false;
  private showToaster = false;
  private tooltipInfoMessage = '';
  private currentModal = EmailBrandingHelper.DeleteDomainModal;
  private domainId = -1;
  private isMobileView = false;

  // Modal Pop up properties
  private modalPopupVisible = false;
  private modalPopupHeading = '';
  private modalPopupBodyHeading = '';
  private showCloseButton = false;
  private showCancelButton = false;
  private showConfirmButton = false;
  private modalPopupContent = '';
  private buttonText = '';
  private cancelButtonText = '';
  private imageIcon = '';

  // Computed property: Automatically updates when Store changes
  public get isPFActive(): boolean {
    const storeHelper = new StoreHelper(Store);
    const reqInfo = storeHelper.GetRequestInfoFromStore();
    // Explicit null/undefined check
    if (reqInfo !== null && reqInfo !== undefined) {
      return reqInfo.IsWhiteLabelledDomainsPFActive;
    }
    return false;
  }

  // Getter to calculate button state reactively
  public get isAddEmailButtonDisabled(): boolean {
    const hasNoDomain = this.domainRecords.Domains.length === 0;
    const hasValidActiveDomain = this.domainRecords.Domains.some((domain) => domain.IsValid);
    const totalEmailsCount = this.emailDomainListings.reduce((total, domain) => total + (domain.Emails ? domain.Emails.length : 0), 0);
    const hasReachedLimit = totalEmailsCount >= EmailBrandingHelper.TotalEmailsLimit;
    return (!hasNoDomain && !hasValidActiveDomain) || hasReachedLimit;
  }

  // Getter for Drawer type
  public get DrawerType(): typeof EmailDomainDrawerTypeEnum {
    return EmailDomainDrawerTypeEnum;
  }

  private mounted(){
    // Check for mobile view
    if(window.innerWidth <= 767){
      this.isMobileView = true;
    }else{
      this.isMobileView = false;
    }
    this.GetListOfEmails();
    this.GetDomianRecords();
    Root.on('close-drawer', ()=>{
      this.openDrawer = false;
      this.domainId = -1;
    });
  }

  // Show hide the information tooltip
  private GetInformationString(val: boolean) {
    if(!this.isPFActive){
      this.isDomainTooltipVisible = val;
      this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.EmailBrandingNotEnablesInfoText').toString();
      return;
    }
    if( this.domainRecords.Domains !== null && this.domainRecords.Domains !== undefined &&  this.domainRecords.Domains.length > 0){
      const [currentDomain] = this.domainRecords.Domains;
      const status = currentDomain.OverallDomainStatus;
      const domainCount = this.domainRecords.Domains.length;
      const emailCount = this.emailDomainListings.length;

      if (domainCount === 1 && status === DomainStatusTypeEnum.Pending && emailCount === 1) {
        this.isDomainTooltipVisible = val;
        this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.DomainVerificationInProgressTooltip').toString();
      }else if (domainCount === 1 && status === DomainStatusTypeEnum.Broken) {
        this.isDomainTooltipVisible = val;
        this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.BrokenRecordInfoText').toString();
      }else if (domainCount === 1 && status === DomainStatusTypeEnum.Verified && emailCount === 2) {
        this.isDomainTooltipVisible = val;
        this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.OnlyOneEmailCanBeAddedInfoText').toString();
      }
    }
  }

  // Common function for showing and hiding toaster message and loader
  private ShowToasterAndLoader(toasterMessage: string) {
    this.toasterMessage = toasterMessage;
    this.showToaster = true;
    setTimeout(() => {
      this.showLoading = false;
      setTimeout(() => {
        this.showToaster = false;
      }, this.toasterDefaultTimeout);
    }, this.loaderDefaultTimeout);
  }

  // Fetch all email listings
  private GetListOfEmails(){
    FetchData('/CustomDomains/GetAppDomains','').then((response) => {
      this.emailDomainListings = response.data.DomainEmails;
    }).catch(()=>{
      // console error if any
    });
  }

  // Open Delete domain record modal
  private ShowConfirmationModal(domainID: number){
    const targetDomain = this.emailDomainListings.find((d) => d.DomainId === domainID);
    let isAppliedEmailInThisDomain = false;
    if(targetDomain !== null && targetDomain !== undefined){
      isAppliedEmailInThisDomain = targetDomain.Emails.some((email) => email.IsApplied);
    }
    if(isAppliedEmailInThisDomain){
      this.modalPopupVisible = true;
      this.showCancelButton = true;
      this.showCloseButton = true;
      this.showConfirmButton = false;
      this.imageIcon = this.infoStatusIcon;
      this.cancelButtonText = this.$t('Button.Close').toString();
      this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.AlertModalHeading').toString();
      this.modalPopupContent = this.$t('OrgSettings.EmailBranding.AlertModalSubHeading').toString();
    }else{
      this.domainId = domainID;
      this.currentModal = EmailBrandingHelper.DeleteDomainModal;
      this.modalPopupVisible = true;
      this.showCancelButton = true;
      this.showCloseButton = true;
      this.showConfirmButton = true;
      this.imageIcon = this.deleteIcon;
      this.cancelButtonText = this.$t('CancelButton').toString();
      this.buttonText = this.$t('DeleteButton').toString();
      this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.DeleteModalHeading').toString();
      this.modalPopupContent = this.$t('OrgSettings.EmailBranding.DeleteModalSubHeading').toString();
    }

  }

  // Function to delete a domain record
  private DeleteDomainData(){
    FetchData('/CustomDomains/DeleteDomain',JSON.stringify({
      domainSendGridId: this.domainId,
    })).then(() => {
      this.domainRecords.Domains = this.domainRecords.Domains.filter((record) => record.Id !== this.domainId);
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to fetch DNS records for the domain
  private GetDomianRecords(){
    FetchData('/CustomDomains/GetDomainsInfo', '').then((response) => {
      this.domainRecords = response.data;
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to verify the status of domain
  private VerifyDomainStatus(domainId: number, domainName: string){
    FetchData('/CustomDomains/VerifyDomainAuthenticationStatus', JSON.stringify({
      domainSendGridId: domainId,
      domainName,
    })).then((response) => {
      const updatedDomain = response.data;
      const selectedDomain = this.domainRecords.Domains.find((item) => item.Id === updatedDomain.Id);
      if(selectedDomain !== null && selectedDomain !== undefined){
        selectedDomain.IsValid = updatedDomain.IsValid;
        if(updatedDomain.IsValid){
          selectedDomain.OverallDomainStatus = EmailBrandingHelper.VerifiedDomain;
        }

        if((selectedDomain.DnsRecords.Spf !== null && selectedDomain.DnsRecords.Spf !== undefined) && (selectedDomain.DnsRecords.Dkim1 !== null && selectedDomain.DnsRecords.Dkim1 !== undefined) && (selectedDomain.DnsRecords.Dkim2 !== null && selectedDomain.DnsRecords.Dkim2 !== undefined) && (selectedDomain.DnsRecords.Dmarc !== null && selectedDomain.DnsRecords.Dmarc !== undefined)){
          selectedDomain.DnsRecords.Spf.IsValid = updatedDomain.DnsRecords.Spf.IsValid;
          selectedDomain.DnsRecords.Dkim1.IsValid = updatedDomain.DnsRecords.Dkim1.IsValid;
          selectedDomain.DnsRecords.Dkim2.IsValid = updatedDomain.DnsRecords.Dkim2.IsValid;
          selectedDomain.DnsRecords.Dmarc.IsValid = updatedDomain.DnsRecords.Dmarc.IsValid;
        }
      }
    }).catch(()=>{
      // console error if any
    });
  }

  // Functionn to set the email address as active email
  private SetEmailAsActive(emailData: EmailListingsModel){
    const toasterMessage = emailData.EmailAddress +  this.$t('OrgSettings.EmailBranding.EmailActivatedToaster').toString();
    this.showLoading = true;
    FetchData('/CustomDomains/SetActiveEmail', JSON.stringify({
      emailEntityId: emailData.EmailId,
    })).then(()=> {
      this.ShowToasterAndLoader(toasterMessage);
      this.emailDomainListings = this.emailDomainListings.map((domain) => ({
        ...domain,
        Emails: domain.Emails.map((email) => ({
          ...email,
          IsApplied: email.EmailId === emailData.EmailId,
        })),
      }));
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to delete an email address from the email listings
  private DeleteEmailAddress(emailData: EmailListingsModel, domainId: number){
    FetchData('/CustomDomains/DeleteEmail', JSON.stringify({
      emailEntityId: emailData.EmailId,
    })).then(()=> {
      this.emailDomainListings = this.emailDomainListings.map((domain) => {
        if (domain.DomainId === domainId) {
          return {
            ...domain,
            Emails: domain.Emails.filter((email) => email.EmailId !== emailData.EmailId),
          };
        }
        return domain;
      });
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to show alert message
  private ShowAlertDialog(){
    this.modalPopupVisible = true;
    this.showCancelButton = true;
    this.showCloseButton = true;
    this.showConfirmButton = false;
    this.imageIcon = this.warningStatusIcon ;
    this.cancelButtonText = this.$t('Button.Close').toString();
    this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.DeleteModalHeadingActiveEmail').toString();
    this.modalPopupContent = this.$t('OrgSettings.EmailBranding.DeleteModalSubHeadingActiveEmail').toString();
  }

  private ConfirmClick(confirmed: boolean) {
    if(confirmed){
      if(this.currentModal === EmailBrandingHelper.DeleteDomainModal){
        this.DeleteDomainData();
      }else{
        // this.DeleteEmailAddress();
      }
    }
    this.modalPopupVisible = false;
  }

  // Display premium feature not enabled text
  private GetWhiteLabelText() {
    return this.$t('OrgSettings.EmailBranding.IsWhiteLabelledDomainsPFActiveText2', {
      link: `<span class="font-weight-600 font-size-14 hyperLink">${this.$t('OrgSettings.EmailBranding.SupportLink')}</span>`,
    });
  }

  // Open drawer to edit email address
  private EditEmailAddressInDrawer(email: EmailListingsModel, domainId: number){
    this.editEmailData = {...email};
    this.selectedDrawerType = EmailBrandingHelper.EmailDrawer;
    this.openDrawer = true;
    this.domainId = domainId;
  }

  // Handler to display add custom domain drawer
  private OpenDrawer(type: number){
    this.selectedDrawerType = type;
    if(type === 1){
      this.editEmailData = EmailListingsModel.createEmpty();
    }
    if (this.domainRecords.Domains.length > 0) {
      const [domain] = this.domainRecords.Domains;
      this.domainId = domain.Id;
    }
    this.openDrawer = true;
  }
}
export default toNative(EmailBranding);

